export default "__VITE_ASSET__4b7h3R80__"